/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Piano.glb --transform 
Files: Piano.glb [103.56KB] > C:\Users\alexr\Documents\Development\Lofi site\public\Instruments\Piano-transformed.glb [7.9KB] (92%)
*/

import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { Sparkles } from "@react-three/drei";

export function Piano(props) {
  const { nodes, materials } = useGLTF("/Instruments/Piano-transformed.glb");
  const [sound, setSound] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const clickHandler = () => {
    console.log("clicked piano");
    if (isPlaying == false) {
      const sound = new Howl({
        src: "/sounds/piano.mp3",
        autoplay: false,
        volume: 0.3,
        onplay: () => {
          setIsPlaying(true);
          //requestAnimationFrame(step);
          // console.log(isPlaying);
          // console.log("on play");
          // requestAnimationFrame(step);
        },
        onend: () => {
          setIsPlaying(false);
        },
      });
      sound.play();

      setSound(sound);
    }
  };

  return (
    <group
      {...props}
      dispose={null}
      onClick={clickHandler}
      onPointerEnter={() => {
        document.body.style.cursor = "pointer";
      }}
      onPointerLeave={() => {
        document.body.style.cursor = "default";
      }}
    >
      {isPlaying && (
        <Sparkles
          count={300}
          scale={3}
          size={100}
          speed={2}
          color={"#00FF00"}
          position={[4.34, 0.391, 2.308]}
        />
      )}
      <group
        position={[4.34, 0.391, 2.308]}
        rotation={[0, -1.283, 0]}
        scale={0.2}
      >
        <mesh
          geometry={nodes["piano_Cube029-Mesh"].geometry}
          material={materials["1A1A1A"]}
        />
        <mesh
          geometry={nodes["piano_Cube029-Mesh_1"].geometry}
          material={materials.FFFFFF}
        />
        <mesh
          geometry={nodes["piano_Cube029-Mesh_2"].geometry}
          material={materials.FFEB3B}
        />
        <mesh
          geometry={nodes["piano_Cube029-Mesh_3"].geometry}
          material={materials.DD9944}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/Instruments/Piano-transformed.glb");
